const BASE_URL_A = "https://d3ywskgc94.execute-api.us-east-1.amazonaws.com/dev/"
const BASE_URL_B = "https://ao5twzd2wj.execute-api.us-east-1.amazonaws.com/dev/"
const BASE_URL_C = "https://j88onrkbk2.execute-api.us-east-1.amazonaws.com/dev/"

// const BASE_URL_A = "https://epx6vsq7rk.execute-api.us-east-1.amazonaws.com/prod/"
// const BASE_URL_B = "https://srltfbjs1l.execute-api.us-east-1.amazonaws.com/prod/"

// const BASE_URL_A = "https://epx6vsq7rk.execute-api.us-east-1.amazonaws.com/prod/"
// const BASE_URL_B = "https://srltfbjs1l.execute-api.us-east-1.amazonaws.com/prod/"
// const BASE_URL_C = "https://qxqqu27zpa.execute-api.us-east-1.amazonaws.com/prod/"

// const BASE_URL_A = "http://localhost:4000/dev/";
// const BASE_URL_B = "http://localhost:5000/dev/";
// const BASE_URL_C = "http://localhost:7000/dev/";
// // const DynamoDB_URL = "http://127.0.0.1:8000"


// const UPLOAD_URL = "https://8x1pz40uv9.execute-api.us-east-1.amazonaws.com/dev/uploadfile/"
const UPLOAD_URL = "https://8x1pz40uv9.execute-api.us-east-1.amazonaws.com/dev/uploadfile/"
const FILE_UPLOAD_URL = "https://okxvsyvxq1.execute-api.us-east-1.amazonaws.com/prod/uploadFile"

export const environment = {
    production: false,

    upload: UPLOAD_URL,
    uploadFileToS3: FILE_UPLOAD_URL,
    // uploadFileToS3: UPLOAD_URL,

    loginUser: BASE_URL_A + "loginUser",
    verifyOtp: BASE_URL_A + "verifyOtp",
    forgotPassword: BASE_URL_A + "forgotPassword",
    resetPassword: BASE_URL_A + "resetPassword",
    getAllCampus: BASE_URL_A + "getAllCampus",


    // user service starts
    getAllDepartment: BASE_URL_A + "getAllDepartment",
    getAllRoles: BASE_URL_A + "getAllRole",
    updateUser: BASE_URL_A + "updateUser",
    getUser: BASE_URL_A + "getUser",
    getAllUsers: BASE_URL_A + "getAllUsers",
    createUser: BASE_URL_A + "createUser",
    findAllUsers: BASE_URL_A + "getAllUserData",
    // user service ends

    // department service starts
    getAllDepartmentsWithCount: BASE_URL_A + "findAndCountAllDepartment",
    createDepartment: BASE_URL_A + "createDepartment",
    updateDepartment: BASE_URL_A + "updateDepartment",
    deleteDepartment: BASE_URL_A + "deleteDepartment",
    // department service ends




    // leads service starts
    getLeadsFields: BASE_URL_A + "getLeadsField",
    addLeadField: BASE_URL_A + "createLeadsField",
    updateLeadField: BASE_URL_A + "updateLeadsField",
    deleteLeadField: BASE_URL_A + "deleteLeadsField",
    createLead: BASE_URL_A + "createLead",
    updateLead: BASE_URL_A + "updateLead",
    getAllLeads: BASE_URL_A + "getLeadsWithCount",
    deleteLead: BASE_URL_A + "deleteLead",
    createBulkLead: BASE_URL_A + "createBulkLead",
    getAllLeadList: BASE_URL_A + "getAllLeadList",
    updateBulkLead: BASE_URL_A + "updateBulkLead",
    deleteBulkLead: BASE_URL_A + "deleteBulkLead",
    getAllLeadSpace: BASE_URL_A + "getAllLeadSpace",
    

    // Course service ends
    updateLeadSpace: BASE_URL_A + "updateLeadSpace",
    createLeadSpace: BASE_URL_A + "createLeadSpace",
    deleteLeadSpace: BASE_URL_A + "deleteLeadSpace",
    getLead: BASE_URL_A + "getLead",
    createLeadNote: BASE_URL_A + "createLeadNote",
    updateLeadNote: BASE_URL_A + "updateLeadNote",
    createLeadTask: BASE_URL_A + "createLeadTask",
    getLeadNotes: BASE_URL_A + "getLeadNotes",
    deleteLeadNote: BASE_URL_A + "deleteLeadNote",
    createLeadCommunicationLog: BASE_URL_A + "createLeadCommunicationLog",

    getLeadTasks: BASE_URL_A + "getLeadTasks",
    deleteLeadTask: BASE_URL_A + "deleteLeadTask",
    updateLeadTask: BASE_URL_A + "updateLeadTask",

    createLeadFollowup: BASE_URL_A + "createleadFollowup",
    getLeadFollowups: BASE_URL_A + "getleadFollowup",
    getAllLeadActivity: BASE_URL_A + "getAllLeadActivity",
    sendEmailUsingSES: BASE_URL_A + "sendEmailUsingSES",
    sendCommunication: BASE_URL_C + "sendCommunication",
    getLeadCommunicationLogs: BASE_URL_A + "getLeadCommunicationLog",
    getAvailableTimeSlots: BASE_URL_A + "getAllFreeTimeSlot",
    scheduleMeeting: BASE_URL_A + "bookAppointment",
    getLeadMeeting: BASE_URL_A + "getAllAppointment",

    // leads service ends


    // whatsapp template service starts
    createWhatsappTemplate: BASE_URL_A + "createWhatsappTemplate",
    getAllGupshupTemplates: BASE_URL_A + "getAllGupshupTemplate",
    updateGupshupTemplate: BASE_URL_A + "updateGupshupTemplate",
    uploadWhatsappTemplateFile  : BASE_URL_C + "uploadMedia",
    uploadFile: BASE_URL_A + "uploadFile",
    refreshGupshupTemplates: BASE_URL_A + "bulkUpdateWhasappTemplateStatus",
    deleteWhatsappTemplate: BASE_URL_A + "deleteTemplateByTemplateId",

    // whatsapp template service ends


    // email template service starts
    getAllEmailTemplate: BASE_URL_A + "getAllEmailTemplate",
    createEmailTemplate: BASE_URL_A + "createEmailTemplate",
    deleteEmailTemplate: BASE_URL_A + "deleteEmailTemplate",
    updateEmailTemplate: BASE_URL_A + "updateEmailTemplate",

    // email template service ends

    // contact group service starts
    getAllContactGroups: BASE_URL_A + "getAllContactGroup",
    createContactGroup: BASE_URL_A + "createContactGroup",
    createContactGroupList: BASE_URL_A + "createContactGroupList",
    getAllContactGroupList: BASE_URL_A + "getAllContactGroupList",
    getAllContactGroupListColumns: BASE_URL_A + "getAllContactGroupListColumns",
    getLeadAndContactId: BASE_URL_A + "getLeadAndContactId",
    updateContactGroup: BASE_URL_A + "updateContactGroup",
    deleteContactGroup: BASE_URL_A + "deleteContactGroup",
    deleteContactGroupList: BASE_URL_A + "deleteContactGroupList",
    getLeadId: BASE_URL_A + "getLeadId",


    // contact group service ends


    // campaign service starts

    getAllManangeCampaign: BASE_URL_A + "getAllCampaign",
    getAllEmailTemplates: BASE_URL_A + "getEmailTemplate",
    getAllWhatsappTemplatesGupshup: BASE_URL_A + "getGupshupTemplate",
    updateCampaign: BASE_URL_A + "updateCampaign",
    createCampaign: BASE_URL_A + "createCampaign",
    getGupshuTemplateById: BASE_URL_A + "getGupshupTemplateById",
    getEmailTemplateById: BASE_URL_A + "getEmailTemplateById",
    runCampaign: BASE_URL_C + "testcampaignBroadcast",
    // runCampaign: BASE_URL_C + "campaignBroadcast",
    deleteCampaign: BASE_URL_A + "deleteCampaign",

    // campaign service ends


    // registration service starts
    getAllRegistrations: BASE_URL_A + "getAllRegistration",
    createDocument: BASE_URL_B + "createDocument",
    getLeadDocuments: BASE_URL_B + "getAllDocuments",
    deleteLeadDocument: BASE_URL_B + "deleteDocument",
    deleteBulkRegistration: BASE_URL_A + "deleteReg",
    deleteRegistration: BASE_URL_A + "deleteReg",
    // registration service ends

    // Application service starts
    createApplication: BASE_URL_A + "createApplication",
    getAllApplication: BASE_URL_A + "getAllApplication",
    updateApplication: BASE_URL_A + "updateApplication",
    getLeadReportDetails: BASE_URL_A + "getLeadReportDetails",
    getLeadCommunicationReport: BASE_URL_B + "getLeadCommunicationReport",
    moveApplicationToEnrollment: BASE_URL_B + "moveApplicationToEnrollment",
    updateEnrollment: BASE_URL_B + "updateEnrollment",
    deleteApplication: BASE_URL_A + "deleteApplication",

    // Application service ends 


    // tickets service starts
    getAllTickets: BASE_URL_B + "getAllTicket",
    createTicket: BASE_URL_B + "createTicket",
    updateTicket: BASE_URL_B + "updateTicket",
    deleteTicket: BASE_URL_B + "deleteTicket",
    updateMultipleTicket: BASE_URL_B + "updateMultipleTicket",
    getFilteredTickets: BASE_URL_B + "getFilteredTicket",
    addTicketComment: BASE_URL_B + "addTicketActivity",
    getTicketActivities: BASE_URL_B + "getTicketActivities",
    updateTicketActivity: BASE_URL_B + "updateTicketActivity",
    deleteTicketActivity: BASE_URL_B + "deleteTicketActivity",
    // tickets service ends


    // analytics service starts
    getLeadAnalytics: BASE_URL_B + "getLeadAnalytics",
    // analytics service ends


    // outlook email hub section start
    outlookInboxEmail: BASE_URL_B + "outlookInboxEmail",
    outlookSentEmail: BASE_URL_B + "outlookSentEmail",
    outlookDraftEmail: BASE_URL_B + "outlookDraftEmail",
    outlookJunkEmail: BASE_URL_B + "outlookJunkEmail",
    deleteOutlookEmail: BASE_URL_B + "deleteOutlookEmail",
    deleteOutlookEmailPermanently: BASE_URL_B + "deleteOutlookEmailPermanently",
    outlookDeletedEmail: BASE_URL_B + "outlookDeletedEmail",
    sendEmailUsingOutlook: BASE_URL_B + "sendEmailUsingOutlook",
    getOutlookEmailWithAttachment: BASE_URL_B + "getOutlookEmailWithAttachment",
    createOutlookDraftEmail: BASE_URL_B + "createOutlookDraftEmail",
    updateOutlookDraftEmail: BASE_URL_B + "updateOutlookDraftEmail",
    sendOutlookDraftEmail: BASE_URL_B + "sendOutlookDraftEmail",
    createOutlookReply: BASE_URL_B + "createOutlookReply",
    sendOutlookReply: BASE_URL_B + "sendOutlookReply",
    createOutlookReplyAll: BASE_URL_B + "createOutlookReplyAll",
    forwardOutlookEmail: BASE_URL_B + "forwardOutlookEmail",
    getOutlookEmailAttachments: BASE_URL_B + "getOutlookEmailAttachments",
    addAttachmentInOutlookReply: BASE_URL_B + "addAttachmentInOutlookReply",
    deleteAttachmentInOutlook: BASE_URL_B + "deleteAttachmentInOutlook",
    getCodeForOutlookToken: BASE_URL_B + "getCodeForOutlookToken",
    revokeAccess: BASE_URL_B + "disconnectOutlook",

    // outlook email hub section end

    // domain auth section start
    getAllClientDomain: BASE_URL_B + "getAllClientDomain",
    authenticateClientDomain: BASE_URL_B + "authenticateClientDomain",
    domainVerificationStatus: BASE_URL_B + "domainVerificationStatus",
    deleteDomainAndEmail: BASE_URL_B + "deleteDomainAndEmail",
    deleteDomain: BASE_URL_B + "deleteDomain", // TODO: Add this endpoint when backend is ready


    // enrollment service starts
    deleteEnrollment: BASE_URL_B + "deleteEnrollment",
    bulkUpdateEnrollment: BASE_URL_A + "bulkUpdateEnrollment",


    // academic year service starts
    getAllAcademicYearsWithCount: BASE_URL_B + "getAllAcademicYearsWithCount",
    createAcademicYear: BASE_URL_B + "createAcademicYear",
    updateAcademicYear: BASE_URL_B + "updateAcademicYear",
    deleteAcademicYear: BASE_URL_B + "deleteAcademicYear",
    getAllAcademicYears: BASE_URL_B + "getAllAcademicYears",
    // academic year service ends



    // fees configuration service starts
    getAllFeeGroupWithCount: BASE_URL_B + "getAllFeeGroups",
    createFeeGroup: BASE_URL_B + "createFeeGroup",
    updateFeeGroup: BASE_URL_B + "updateFeeGroup",
    deleteFeeGroup: BASE_URL_B + "deleteFeeGroup",
    // fees configuration service ends

    // fee structure service starts
    getAllFeeStructures: BASE_URL_B + "getAllFeeStructures",
    createFeeStructure: BASE_URL_B + "createFeeStructure",
    updateFeeStructure: BASE_URL_B + "updateFeeStructure",
    deleteFeeStructure: BASE_URL_B + "deleteFeeStructure",
    getAllActiveFeeGroups: BASE_URL_B + "getAllActiveFeeGroups",
    // fee structure service ends


    // batch service starts
    getAllBatches: BASE_URL_B + "getAllBatches",
    createBatch: BASE_URL_B + "createBatch",
    updateBatch: BASE_URL_B + "updateBatch",
    deleteBatch: BASE_URL_B + "deleteBatch",
    getAllBatchesWithCount: BASE_URL_B + "findAndCountAllBatches",
    // batch service ends


        // Course service starts
    getAllCourses: BASE_URL_B + "getAllCourses",
    createCourse: BASE_URL_B + "createCourse",
    updateCourse: BASE_URL_B + "updateCourse",
    deleteCourse: BASE_URL_B + "deleteCourse",
    findAndCountAllCourses: BASE_URL_B + "findAndCountAllCourses",


    uploadContactsToGroup: BASE_URL_B + "uploadContactsToGroup",
    getContactsInDynamoDBGroup: BASE_URL_B + "getContactsInDynamoDBGroup",
    getContactsReportInDynamoDBGroup: BASE_URL_B + "getContactsReportInDynamoDBGroup",
    runTelephonyCampaign: BASE_URL_B + "runTelephonyCampaign",
    getCountOfContactsInGroup: BASE_URL_B + "getCountOfContactsInGroup",
    testDialCustomer : BASE_URL_B + "testDialCustomer",
    deleteContactsFromGroup: BASE_URL_B + "deleteContactsFromGroup",
    getEmailCampaignReport  : BASE_URL_C + "getCampaignTracking",
    getWhatsappCampaignReport: BASE_URL_C + "getWhatsappCampaignTracking",
    testWhatsappCampaign: BASE_URL_C + "testWhatsappCampaign",
    testEmailCampaign: BASE_URL_C + "testEmailCampaign",


    getAllAdmissionsWithCount: BASE_URL_B + "getAllAdmissionsWithCount",
    moveToAdmission : BASE_URL_B + "moveToAdmission",
    updateAdmission : BASE_URL_B + "updateAdmission",
    getAdmission: BASE_URL_B + "getAdmission",
    addAdmission: BASE_URL_B + "addAdmission",
    bulkUpdateAdmissions: BASE_URL_B + "bulkUpdateAdmission",
    deleteAdmission: BASE_URL_B + "deleteAdmission",
    bulkDeleteAdmission: BASE_URL_B + "bulkDeleteAdmission",
    findDuplicateWithCount: BASE_URL_C + "findDuplicateWithCount",
    deleteAllDuplicates: BASE_URL_C + "deleteAllDuplicates",
    deleteDuplicateByEmailPhone: BASE_URL_C + "deleteDuplicateByEmailPhone",




        // hostel service starts
    getAllHostelCategoriesWithCount: BASE_URL_C + "getAllHostelWithCount",
    createHostelCategory: BASE_URL_C + "createHostelCategory",
    updateHostelCategory: BASE_URL_C + "updateHostelCategory",
    deleteHostelCategory: BASE_URL_C + "deleteHostelCategory",
    getAllHostelCategories: BASE_URL_C + "getAllHostelCategories",
    // hostel service ends


    
    // scholarship service starts
    getAllScholarshipsWithCount: BASE_URL_C + "findAndCountAllScholarships",
    createScholarship: BASE_URL_C + "createScholarship",
    updateScholarship: BASE_URL_C + "updateScholarship",
    deleteScholarship: BASE_URL_C + "deleteScholarship",
    getScholarshipById: BASE_URL_C + "getScholarshipById",
    getAllScholarships: BASE_URL_C + "getAllScholarships",
    // scholarship service ends

    // transport service starts
    getAllTransportsWithCount: BASE_URL_C + "getAllTransportsWithCount",
    createTransport: BASE_URL_C + "createTransportCategory",
    updateTransport: BASE_URL_C + "updateTransportCategory",
    deleteTransport: BASE_URL_C + "deleteTransportCategory",
    getTransportById: BASE_URL_C + "getTransportById",
    getAllTransportCategories: BASE_URL_C + "getAllTransportCategories",
    // transport service ends

    
    // roll number configuration service starts
    getAllRollNumberConfigsWithCount: BASE_URL_C + "getAllRollNumberConfigsWithCount",
    createRollNumberConfig: BASE_URL_C + "createRollNumberConfig",
    updateRollNumberConfig: BASE_URL_C + "updateRollNumberConfig",
    deleteRollNumberConfig: BASE_URL_C + "deleteRollNumberConfig",
    // roll number configuration service ends


        // student service starts
    getAllStudentsWithCount: BASE_URL_C + "getAllStudentsWithCount",
    moveToStudent: BASE_URL_C + "admissionToStudent", 
    updateStudent: BASE_URL_C + "updateStudent",
    getStudentById: BASE_URL_C + "getStudent",
    deleteStudent: BASE_URL_C + "deleteStudent",
    createStudent: BASE_URL_C + "createStudent",
    updateBulkStudents: BASE_URL_C + "updateBulkStudents",
    createStudentTempProfile: BASE_URL_C + "createStudentTempProfile",
    getStudentTempProfileByUUID: BASE_URL_C + "getStudentTempProfileByUUID",
    // student service ends

    // lead advance filter
    leadAdvanceFilter: BASE_URL_C + "leadAdvanceFilter",

    // pipeline configuration service starts
    getPipelines: BASE_URL_C + "getAllPipelines",
    createPipeline: BASE_URL_C + "createPipeline",
    updatePipeline: BASE_URL_C + "updatePipeline",
    deletePipeline: BASE_URL_C + "deletePipeline",
    // pipeline configuration service ends

    // contact service starts
    getAllContactsWithCount: BASE_URL_C + "getAllContactsWithCount",
    createContact: BASE_URL_C + "createContact",
    updateContact: BASE_URL_C + "updateContact",
    deleteContact: BASE_URL_C + "deleteContact",
    getContactById: BASE_URL_C + "getContactById",
    // contact service ends

    // configuration panel service starts
    // notification configuration
    getAuthorizedDomains: BASE_URL_A + "getAuthorizedDomains",
    getNotificationEmails: BASE_URL_A + "getNotificationEmails",
    addNotificationEmail: BASE_URL_A + "addNotificationEmail",
    deleteNotificationEmail: BASE_URL_A + "deleteNotificationEmail",
    getModuleEmailAssignments: BASE_URL_A + "getModuleEmailAssignments",
    saveModuleEmailAssignments: BASE_URL_A + "saveModuleEmailAssignments",
    
    // communication configuration
    getCommunicationConfig: BASE_URL_A + "getCommunicationConfig",
    getOutlookAuthUrl: BASE_URL_A + "getOutlookAuthUrl",
    getGmailAuthUrl: BASE_URL_A + "getGmailAuthUrl",
    checkOutlookConnection: BASE_URL_B + "checkOutlookConnection",
    disconnectOutlook: BASE_URL_A + "disconnectOutlook",
    disconnectGmail: BASE_URL_C + "disconnectGmail",
    saveOutlookToken: BASE_URL_A + "saveOutlookToken",
    saveGmailToken: BASE_URL_A + "saveGmailToken",
    getCodeForGmailToken: BASE_URL_C + "getCodeForGmailToken",
    checkGmailConnection: BASE_URL_C + "checkGmailConnection",
    
    // whatsapp configuration
    getWhatsAppConfig: BASE_URL_A + "getWhatsAppConfig",
    saveWhatsAppConfig: BASE_URL_A + "saveWhatsAppConfig",
    testWhatsAppConnection: BASE_URL_A + "testWhatsAppConnection",
    // configuration panel service ends

    // form builder service starts
    apiUrl: BASE_URL_A,
    getDynamicFormList: BASE_URL_C + "getAllDynamicForms",
    // form builder service ends

    // organization configuration service starts
    getOrgConfigById: BASE_URL_A + "getOrgConfigById",
    updateOrgConfig: BASE_URL_A + "updateOrgConfig",
    createOrgConfig: BASE_URL_A + "createOrgConfig",


    createDynamicForm: BASE_URL_C + "createDynamicForm",
    updateDynamicForm: BASE_URL_C + "updateDynamicForm",
    getDynamicFormByToken: BASE_URL_C + "getDynamicFormByToken",
    deleteDynamicForm: BASE_URL_C + "deleteDynamicForm",
    submitPublicForm: BASE_URL_C + "addFormData",
};


